export default "__VITE_ASSET__BgNCihYF__"